<template>
  <div>
    <el-form role="form" @submit.prevent.native="onSubmit">
      <div class="row">
        <div class="col-md-6">
          <base-input label="Select Service Category">
            <el-select
              v-model="serviceJob.serviceCategoryId"
              filterable
              @change="changeServicesByCategory"
            >
              <el-option
                v-for="(item, index) in serviceCategories"
                :key="index"
                :value="item.serviceCategoryId"
                :label="item.label"
              />
            </el-select>
          </base-input>
          <base-input label="Job Name">
            <el-select
              v-model="serviceJob.jobs"
              multiple
              allow-create
              filterable
            >
              <el-option
                v-for="(item, index) in jobList"
                :key="index"
                :value="item.description"
                :label="item.description"
            /></el-select>
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input label="Select Service">
            <el-select v-model="serviceJob.serviceId">
              <el-option
                v-for="(item, index) in services"
                :key="index"
                :value="item.serviceId"
                :label="item.label"
              />
            </el-select>
          </base-input>
        </div>
      </div>
      <base-button md type="primary" native-type="submit">Save</base-button>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { Select, Option, Autocomplete, Form } from "element-ui";
export default {
  directives: {
    uppercase: {
      inserted: function (el, _, vnode) {
        el.addEventListener("input", async function (e) {
          const modified = e.target.value
            .split(" ")
            .map((i) => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      },
    },
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Autocomplete.name]: Autocomplete,
    [Form.name]: Form,
  },
  data: () => {
    return {
      services: [],
    };
  },

  computed: {
    ...mapState("serviceJob", ["serviceJob"]),
    ...mapGetters({
      serviceCategories: "serviceCategory/getServiceCategoryList",
      jobList: "job/getJobList",
      serviceJobList: "serviceJob/getJobList",
    }),
  },
  watch: {
    serviceJob: {
      handler: function (newValue) {
        if (newValue && newValue.serviceCategoryId) {
          this.fetchServices(newValue.serviceCategoryId);
        }
      },
      immediate: true,
      deep: true,
    },
  },

  mounted() {
    this.getServiceCategories();
    this.getJobList();
  },

  methods: {
    ...mapActions({
      saveServiceJob: "serviceJob/saveServiceJob",
      getServiceJobList: "serviceJob/getServiceJobList",
      updateServiceJob: "serviceJob/updateServiceJob",
      getServiceList: "service/getServiceList",
      getServiceCategories: "serviceCategory/getServiceCategoryList",
      getServicesByCategoryId: "service/getServicesByCategoryId",
      getJobList: "job/getJobList",
    }),
    async fetchServices(serviceCategoryId) {
      this.services = await this.getServicesByCategoryId({ serviceCategoryId });
      this.serviceJob.serviceId = this.serviceJob.serviceId;
    },
    async changeServicesByCategory(serviceCategoryId) {
      this.serviceJob.serviceId = "";
      this.services = await this.getServicesByCategoryId({ serviceCategoryId });
    },
    querySearch(queryString, cb) {
      var jobs = this.jobList;
      var results = queryString
        ? jobs.filter(this.createFilter(queryString))
        : jobs;
      cb(results);
    },
    createFilter(queryString) {
      return (link) => {
        return (
          link.description.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleSelect(item) {
      if (item.jobId) {
        this.serviceJob.label = item.description;
      }
    },
    duplicateMessage() {
      const names = (this.serviceJob.jobs || [])
        .map((name) => (name || "").trim())
        .filter(Boolean);
      const label = (this.serviceJob.label || "").trim();
      const keys = names.length ? names : label ? [label] : [];
      if (!keys.length || !this.serviceJob.serviceId) return "";

      const seen = new Set();
      const repeated = [];
      keys.forEach((name) => {
        const key = name.toLowerCase();
        if (seen.has(key)) repeated.push(name);
        else seen.add(key);
      });
      if (repeated.length) {
        return `Duplicate job names in this form: ${repeated.join(", ")}`;
      }

      const existing = new Set(
        (this.serviceJobList || [])
          .filter(
            (row) =>
              row.serviceId === this.serviceJob.serviceId &&
              row.serviceJobId !== this.serviceJob.serviceJobId
          )
          .map((row) => (row.label || "").trim().toLowerCase())
      );
      const clashes = keys.filter(
        (name, index) =>
          keys.findIndex((item) => item.toLowerCase() === name.toLowerCase()) === index &&
          existing.has(name.toLowerCase())
      );
      if (clashes.length) {
        return `These jobs already exist for this service: ${clashes.join(", ")}`;
      }
      return "";
    },
    notifySaveError(err) {
      const details =
        err && err.response && err.response.data && err.response.data.details;
      if (Array.isArray(details) && details.length) {
        details.forEach((item) => {
          this.$notify({
            message: item.message,
            type: "danger",
            title: "Validation Error",
          });
        });
        return;
      }
      this.$notify({
        message: "Could not save.",
        type: "danger",
        title: "Error",
      });
    },
    onSubmit() {
      const duplicate = this.duplicateMessage();
      if (duplicate) {
        this.$notify({
          message: duplicate,
          type: "danger",
          title: "Validation Error",
        });
        return;
      }
      if (this.serviceJob.serviceJobId) {
        this.updateServiceJob().then((res) => {
          this.$notify({
            message: "Job Updated Succesfully!",
            type: "success",
            title: "Succes",
          });
          this.getServiceJobList();
          this.$emit("close");
        }).catch((err) => this.notifySaveError(err));
      } else {
        this.saveServiceJob().then((res) => {
          this.$notify({
            message: "Job Created Succesfully!",
            type: "success",
            title: "Success",
          });
          this.getServiceJobList();
          this.$emit("close");
        }).catch((err) => this.notifySaveError(err));
      }
    },
  },
};
</script>